import(/* webpackMode: "eager" */ "/home/u309158901/domains/aethera-defi.com/hbuilds/source/repository/src/app/page.tsx");
